import WMSLayer from '@arcgis/core/layers/WMSLayer';
import { GISServiceTypes } from '../gisServicesTypes';
import { ensureLoadedLayerArray, LayerLoader } from './LayerLoader';
import { resolveAdminOpacity } from './defaultLayerLoader';
import { parseOgcServiceUrl } from './parseOgcServiceUrl';

/**
 * Standalone WMS services configured in Andromeda.
 * Auth keys pasted on the URL are moved to `customParameters` so they apply to
 * GetCapabilities as well as GetMap (see Esri customParameters vs
 * customLayerParameters).
 */
export const wmsLayerLoader: LayerLoader = {
  shouldUseLoader(service) {
    return service.service_type == GISServiceTypes.wms;
  },
  async load(service) {
    const layerNames = service?.attributes?.sublayers || [];
    const adminOpacity = resolveAdminOpacity(service);
    const { url, customParameters, wmsLayerName } = parseOgcServiceUrl(
      service.gis_service_url,
    );

    const resolvedNames =
      layerNames.length > 0 ? layerNames : wmsLayerName ? [wmsLayerName] : [];

    const layer = new WMSLayer({
      id: service.gisLayerID,
      url,
      visible: false,
      sublayers: resolvedNames.map(name => ({ name })),
      ...(customParameters ? { customParameters } : {}),
      ...(adminOpacity !== undefined ? { opacity: adminOpacity } : {}),
    });

    await layer.load();
    return ensureLoadedLayerArray(layer);
  },
};
